import { createClient, type SupabaseClient } from "@supabase/supabase-js"
import type { PublicConfig } from "@shared/api"

/**
 * Cliente de Supabase del browser. SOLO PARA AUTENTICAR.
 *
 * Los datos NUNCA se leen con él: overtime_requests tiene RLS activo sin policies más
 * un `revoke all from anon, authenticated`, y la vista del tablero va con
 * security_invoker = on tras el mismo revoke (supabase/dashboard.sql), así que la
 * anon key no alcanza nada. Todo lo que es dato pasa por /api/dashboard/* con el
 * bearer token (ver services/api.ts).
 *
 * SIN SIDE-EFFECTS DE MÓDULO, a diferencia de
 * calendar-app (src/config/supabaseClient.js), que crea el cliente al importarse y
 * por eso necesita los placeholders 'http://localhost:54321' /
 * 'public-anon-key-placeholder' para no dejar la pantalla en blanco cuando faltan las
 * env vars. Acá la config llega en runtime, así que initSupabase() se llama desde
 * main.tsx DESPUÉS del fetch y ANTES del primer render.
 */
let client: SupabaseClient | null = null

export function initSupabase(cfg: PublicConfig): SupabaseClient {
  // Opciones POR DEFAULT a propósito:
  //   · persistSession   → localStorage, clave sb-<ref>-auth-token
  //   · autoRefreshToken → el access token se renueva solo
  //   · detectSessionInUrl → es lo que COMPLETA el link de recovery, que llega como
  //     hash (#access_token=…&type=recovery) porque flowType queda en implicit.
  //
  // Ese hash es también la razón por la que este SPA NO usa hash routing: un router
  // de hash intentaría matchear eso como ruta y rompería el reset de contraseña. La
  // navegación va en el QUERY STRING (ver hooks/useQueryState.ts).
  client = createClient(cfg.supabaseUrl, cfg.supabaseAnonKey)
  return client
}

export function getSupabase(): SupabaseClient {
  if (!client) {
    // Solo puede pasar si alguien renderiza sin pasar por el bootstrap de main.tsx.
    throw new Error("initSupabase() no se llamó antes de renderizar")
  }
  return client
}
